import React, { useEffect, useState } from 'react';

// eslint-disable-next-line no-unused-vars
import moment from 'moment';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import crown from 'ui/assets/img/crown-emoji.png';
import wave from 'ui/assets/img/hello-emoji.png';
import { Loader } from 'ui/components';
import MainFont from 'ui/typography/mainFont';

import {
  AddFriendContainer,
  InfoContainer,
  InfoData,
  InfoDescription,
  InfoDescriptionRow,
  TableDataContainer,
  TableRows,
  UserInfoCard,
  UserInfoCardContent,
  UserInfoCardDeleteSection,
  UserInfoCardTitle,
  UserInfoCardTitleContainer,
  UserInfoIcon,
  UsersCardContainer
} from './style';

const UsersCard = ({ ownerId, friendsIds, rfids }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [ownerRfids, setOwnerRfids] = useState({});
  const [friendsRfids, setFriendsRfids] = useState([]);

  useEffect(() => {
    if (rfids && rfids.length !== 0) {
      const ownerData = {
        userId: ownerId,
        associationDate: '',
        rfids: []
      };
      const friendsData = [];
      rfids.forEach(rfid => {
        if (rfid.userId === ownerId) {
          ownerData.rfids = [...ownerData.rfids, rfid];
        } else {
          const index = friendsData.findIndex(el => el.userId === rfid.userId);
          if (index !== -1) {
            friendsData[index].rfids.push(rfid);
          } else {
            friendsData.push({
              userId: rfid.userId,
              associationDate: '',
              rfids: [rfid]
            });
          }
        }
      });
      setOwnerRfids({ ...ownerData });
      setFriendsRfids([...friendsData]);
      setIsLoading(false);
    }
  }, [ownerId, friendsIds, rfids]);

  const loadInfo = info => (
    <>
      <InfoDescription header>
        {' '}
        <MainFont configuration={{ fontSize: 12 }}>{info.descr}</MainFont>
      </InfoDescription>
      <InfoData header>
        <MainFont configuration={{ fontSize: 12 }}> {info.data}</MainFont>
      </InfoData>
    </>
  );

  const loadTable = rfidsData => (
    <TableDataContainer>
      <TableRows header>
        <InfoDescriptionRow lighter>
          {' '}
          <MainFont configuration={{ fontSize: 12 }}>
            RFID serial number
          </MainFont>
        </InfoDescriptionRow>
        <InfoDescriptionRow lighter>
          {' '}
          <MainFont configuration={{ fontSize: 12 }}>Activation Date</MainFont>
        </InfoDescriptionRow>
        <InfoDescriptionRow lighter>
          {' '}
          <MainFont configuration={{ fontSize: 12 }}>Status</MainFont>
        </InfoDescriptionRow>
      </TableRows>
      {rfidsData?.map((u, index) => (
        <TableRows key={index}>
          <InfoDescriptionRow>
            <InfoData>
              <MainFont configuration={{ fontSize: 12 }}>
                {' '}
                {u.rfidNumber}
              </MainFont>
            </InfoData>
          </InfoDescriptionRow>
          <InfoDescriptionRow>
            <InfoData>
              <MainFont configuration={{ fontSize: 12 }}>
                {' '}
                {moment(u.activationDate).isValid()
                  ? moment(u.activationDate).format('DD/MM/YY HH:MM')
                  : '-'}
              </MainFont>
            </InfoData>
          </InfoDescriptionRow>
          <InfoDescriptionRow status>
            <InfoData status={u.status.toLowerCase()}>
              <MainFont configuration={{ fontSize: 12 }}> {u.status}</MainFont>
            </InfoData>
          </InfoDescriptionRow>
        </TableRows>
      ))}
    </TableDataContainer>
  );

  const loadCard = (cardData, isOwner) => (
    <UsersCardContainer>
      <UserInfoCard>
        <UserInfoCardTitleContainer>
          <UserInfoCardTitle>
            <UserInfoIcon>
              {isOwner ? (
                <img src={crown} alt="owner-icon" />
              ) : (
                <img src={wave} alt="associated-friend-icon" />
              )}
            </UserInfoIcon>
            <MainFont configuration={{ fontSize: 16 }} type="4">
              {isOwner ? t('owner') : t('friend')}
            </MainFont>
            <InfoContainer>
              {loadInfo({
                descr: 'User ID: ',
                data: cardData?.userId
              })}
            </InfoContainer>
            <InfoContainer addedMargin>
              {loadInfo({
                descr: 'Association date: ',
                data: moment(cardData?.associationDate).isValid()
                  ? moment(cardData?.associationDate).format('DD/MM/YY HH:MM')
                  : '-'
              })}
            </InfoContainer>
            <InfoContainer>
              {loadInfo({
                descr: 'Associated Rfid: ',
                data: cardData?.rfids?.length
              })}
            </InfoContainer>
          </UserInfoCardTitle>
          {!isOwner && (
            <UserInfoCardDeleteSection>
              <span className="icon-bin" />
              <MainFont configuration={{ fontSize: 14 }} type="4">
                {t('remove')}
              </MainFont>
            </UserInfoCardDeleteSection>
          )}
        </UserInfoCardTitleContainer>
        <UserInfoCardContent>{loadTable(cardData.rfids)}</UserInfoCardContent>
      </UserInfoCard>
    </UsersCardContainer>
  );

  const renderAddFriend = () => (
    <AddFriendContainer>
      <span className="icon-add" />
      <MainFont configuration={{ fontSize: 14 }} type="4">
        {t('add_friend')}
      </MainFont>
    </AddFriendContainer>
  );

  if (isLoading) {
    return <Loader isLoading={isLoading} />;
  }
  return (
    <>
      {loadCard(ownerRfids, true)}
      {renderAddFriend()}
      {friendsRfids.map(friend => loadCard(friend, false))}
    </>
  );
};

UsersCard.propTypes = {
  ownerId: PropTypes.string,
  friendsIds: PropTypes.array,
  rfids: PropTypes.array
};

export default connect(
  state => ({
    ownerId: state?.cpDetails?.details?.userId,
    friendsIds: state?.cpDetails?.details?.secondaryUsers,
    rfids: state?.cpDetails?.rfid
  }),
  dispatch => ({})
)(UsersCard);
